import { api } from "@/lib/api";
import { getSessionId, getVisitId } from "@/lib/device";

let _pageviewSent = false;

function _pickUtm() {
  // Parse UTM params + Google Ads `gclid` out of the current URL so the
  // backend can distinguish Google Ads from Google organic Search.
  try {
    const q = new URLSearchParams(window.location.search);
    // Click IDs added by ad/social platforms when the referrer is stripped.
    const CLICK_IDS = [
      ["gclid", "google", "cpc"], ["gbraid", "google", "cpc"], ["wbraid", "google", "cpc"],
      ["msclkid", "bing", "cpc"], ["ttclid", "tiktok", "cpc"], ["li_fat_id", "linkedin", "cpc"],
      ["fbclid", "facebook", "social"], ["igshid", "instagram", "social"], ["srsltid", "google", "organic"],
    ];
    const hit = CLICK_IDS.find(([k]) => q.has(k));
    const utm_source = q.get("utm_source") || q.get("ref") || (hit ? hit[1] : null);
    const utm_medium = q.get("utm_medium") || (hit && !q.get("utm_source") ? hit[2] : null);
    const utm_campaign = q.get("utm_campaign") || null;
    return { utm_source, utm_medium, utm_campaign };
  } catch { return {}; }
}

export async function sendPageview(path) {
  if (_pageviewSent) return;
  _pageviewSent = true;
  try {
    const payload = {
      path: path || window.location.pathname,
      session_id: getSessionId(),
      visit_id: getVisitId(),
      referrer: (typeof document !== "undefined" ? document.referrer : "") || "",
      ..._pickUtm(),
      team: !!localStorage.getItem("propertic_token"),
    };
    await api.post("/track/pageview", payload);
  } catch { /* silent */ }
}

export async function sendClick(type, path) {
  try {
    return await api.post("/track/click", { type, path: path || window.location.pathname });
  } catch { /* silent */ }
}
